import { Box, useTheme } from "@mui/material";
import SettingsHeaderTabs from "../components/settings-page/SettingsHeaderTabs";
import { SettingsPageText } from "../data/texts";
import { useState } from "react";
import ProfileScreen from "../components/settings-page/ProfileScreen";
import BillingScreen from "../components/settings-page/BillingScreen";
import NotificationsScreen from "../components/settings-page/NotificationsScreen";
import SecurityScreen from "../components/settings-page/SecurityScreen";
import useScreen from "../components/common/UseScreen";
const SettingsPage = () => {
  const [selectedTab, setSelectedTab] = useState(SettingsPageText.PROFILE);
  const theme = useTheme();
  const { isDesktop } = useScreen();
  return (
    <Box
      sx={{
        padding: isDesktop ? "24px" : "0",
        background: theme.palette.background.default,
      }}
    >
      <SettingsHeaderTabs
        sx={{ margin: !isDesktop ? "24px" : "0", marginBottom: "24px" }}
        onTabClick={setSelectedTab}
        selectedTab={selectedTab}
      />
      {selectedTab === SettingsPageText.PROFILE && <ProfileScreen />}
      {selectedTab === SettingsPageText.BILLING && <BillingScreen />}
      {selectedTab === SettingsPageText.NOTIFICATIONS && (
        <NotificationsScreen />
      )}
      {selectedTab === SettingsPageText.SECURITY && <SecurityScreen />}
    </Box>
  );
};

export default SettingsPage;
